import { UserProvider } from './../../providers/user/user';
import { UserSubscriptionCoinbaseComponent } from './../user-subscription-coinbase/user-subscription-coinbase';
import { ToastService } from './../../providers/util/toast.service';
import { BtBackendProvider } from './../../providers/bt-backend/bt-backend';
import { Subscription } from './../../models/User';
import { NavController } from 'ionic-angular/navigation/nav-controller';
import { ViewController, NavParams, AlertController, LoadingController, ModalController } from 'ionic-angular';
import { Component } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { User } from '../../models/User';

@Component({
  selector: 'user-subscription',
  templateUrl: 'user-subscription.html'
})
export class UserSubscriptionComponent {


  text: string;
  sub: Subscription;
  plan: string;
  user: User;

  showCard: boolean = false;
  choosePaymentMethod: boolean = false;
  showRefButton: boolean = false;

  constructor(
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public params: NavParams,
    public alertCtrl: AlertController,
    public iab: InAppBrowser,
    public backend: BtBackendProvider,
    public loadingCtrl: LoadingController,
    public toast: ToastService,
    public modalCtrl: ModalController,
    public userCtrl: UserProvider
  ) {
    this.sub = params.get('sub');
    this.user = params.get('user');
  }

  ngOnInit(){
    if(this.sub.status == 'UNPAID'){
      this.showCard = true;
      this.plan = this.sub.plan;
    }

    if(this.sub.refId == null || this.sub.refId == 'NONE'){
      this.showRefButton = true;
    }
  }

  changePlan(plan: string){
    this.plan = plan;
    this.showCard = true;
  }

  endSubscription(){
    let alert = this.alertCtrl.create({
      title: 'End Subscription',
      subTitle: 'Your subscription will remain until the end of the period, but you will not be charged for the next cycle.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'End Subscription',
          handler: () => {
            let loader = this.loadingCtrl.create();
            loader.present();
            this.backend.endSubscription().first().subscribe((val) => {
              loader.dismiss();
              this.viewCtrl.dismiss();
            }, error =>{
              console.log(error);
              loader.dismiss();
            })
          }
        }
      ]
    })
    alert.present();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  getPrice(plan: string): string{
    return this.prices[plan];
  }

  getDate(dateString: string): string{
    return (parseInt(dateString) * 1000).toString();
  }

  onProcessed(event: boolean){
    this.viewCtrl.dismiss();
    if(event){
      this.toast.create(`Thanks! You are subscribed. The Subscription should show as 'Active' in just a few moments. If you have any issues please contact us.`, true, 3000);
    }else{
      this.toast.create(`Thanks! Have a look at the Coinbase payment page we sent you to, it should have a link to your transaction on the blockchain. Once that is complete, you will have access. If you have any issues please contact us.`, true, 3000);

    }
  }

  private prices = {
    '1month': '199.99',
    '12month': '1,999.99'
  }

  payWithCrypto(){
    let modal = this.modalCtrl.create(UserSubscriptionCoinbaseComponent);
    modal.present();
  }

  promptRef(){
    let alert = this.alertCtrl.create({
      title: 'Referral Code',
      message: 'Did someone bring you here? Show them some love and paste the link they gave you or their code.',
      inputs: [
        {
          name: 'ref',
          placeholder: 'URL or code goes here',
          type: 'text'
        }
      ],
      buttons: [
        {
          text: 'Ok',
          handler: data => {
            let ref = data['ref'];
            this.setRefCode(ref);
          }
        },
        {
          text: 'Cancel',
          role: 'cancel'
        }
      ]
    })
    alert.present();
  }

  private setRefCode(ref: string){
    if(ref){
      if(ref.indexOf('fp_ref') != -1){
        ref = this.userCtrl.parseUrlForRefId(ref);
      }
      let loader = this.loadingCtrl.create();
      loader.present();
      this.userCtrl.setReferralCode(ref).subscribe(response => {
        loader.dismiss();
        if(response.success){
          this.toast.create(`Referral code ${ref} set. Thanks!`);
          this.showRefButton = false;
        }
      }, error => {
        loader.dismiss();
        this.toast.create(`Referral code ${ref} isn't valid. Try again?`);
        console.log(error);
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/user-subscription/user-subscription.ts